import { Compilation } from '../interfaces/compilations.interfaces';
import { transformQuestFromServer } from './quest.functions';
import { transformObeliskFromServer } from './exploration.functions';
import { Dict } from '../interfaces/common.interfaces';

/**
 * Transforms a compilation object from server (snake_case) to client (camelCase) format
 * @param data Raw compilation data from server
 * @param apiUrl API URL for transforming nested quests
 * @returns Transformed Compilation object
 */
export function transformCompilationFromServer(data: Dict<any>, apiUrl: string): Compilation {
  const questsCount = data['quests_count'] ?? 0;
  const completedQuestsCount = data['count_completed_quests'] ?? 0;
  const obelisksCount = data['obelisks_count'] ?? 0;
  const visitedObelisksCount = data['count_visited_obelisks'] ?? 0;

  const totalEntitiesCount = questsCount + obelisksCount;

  const progress = Math.round((totalEntitiesCount === 0 ? 0 : (completedQuestsCount + visitedObelisksCount) / totalEntitiesCount) * 100);

  const tripConfig = data['trip_config'] ?? {};

  return {
    id: data['id'],
    name: data['name'],
    description: data['description'],
    isPublic: data['is_public'],
    onlyForEvents: data['only_for_events'],
    type: data['type'],
    questsCount,
    completedQuestsCount,
    obelisksCount,
    visitedObelisksCount,
    progress,
    quests: data['quests']?.map(quest => transformQuestFromServer(quest, apiUrl)) ?? [],
    obelisks: data['obelisks']?.map(obelisk => transformObeliskFromServer(obelisk)) ?? [],
    creator: {
      id: data['creator'],
      username: data['creator_username']
    },
    location: data['geom'] ? {
      lng: data['geom']['coordinates'][1],
      lat: data['geom']['coordinates'][0]
    } : undefined,
    tripConfig: {
      ...tripConfig,
      titleImageUrl: tripConfig['title_image_url']
    },
    activityTags: data['activity_tags'] ?? [],
    isFavorite: data['is_favorite']
  };
}

